export default "__VITE_PUBLIC_ASSET__873cf278__"